<template>
    <div id="layoutSidenav_content">
        <slot name="Main"></slot>
        <slot name="Footer"></slot>
    </div>
</template>

<script>
  export default {
    name: 'layoutSidenav_content',
  };
</script>

<style scoped>

</style>
